import { TextField } from "@mui/material";
import { useContext } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
//
// ################################################################################
//
const ArregloObservaciones = () => {
  const { arregloObservaciones, handleChangeArregloObservaciones, gaAction } =
    useContext(GestionAtencionContext);

  const { observaciones } = arregloObservaciones;

  return (
    <>
      <TextField
        sx={{ width: "100%", mb: 1 }}
        id="observaciones"
        variant="outlined"
        multiline
        maxRows={5}
        name="observaciones"
        value={observaciones}
        onChange={handleChangeArregloObservaciones}
        disabled={gaAction.cu === "view"}
      />
    </>
  );
};
export default ArregloObservaciones;
